import React from 'react';
import { Controller } from 'react-hook-form';

interface ISecurityFireAlarmSystemCheckBox {
    name: string,
    label: string,
    control: any
};

export const SecurityFireAlarmSystemCheckBox = ({
    name,
    label,
    control
}: ISecurityFireAlarmSystemCheckBox) => {
    return (
        <Controller
            name={name}
            control={control}
            render={({ field }) => (
                <div className="py-1 w-full text-xs">
                    <div className="grid grid-cols-1 md:grid-cols-3 content-center items-center w-full gap-1">
                        <label
                            className="flex space-x-1 justify-start expandedLabel fontExpand"
                        >
                            {label}:
                        </label>

                        <input
                            type="checkbox"
                            checked={field.value}
                            className={`w-4 h-4 border-gray-50 cursor-pointer hover:cursor-pointer`}
                            onChange={(e) => field.onChange(e.target.checked)}
                        />
                    </div>
                </div>
            )}
        />
    )
}
